export const deriveVerificationState = ({
  kycStatus,
  bankStatus,
  stripeConnected,
  payoutMethod,
}) => {
  const kycApproved = kycStatus === "approved";

  const stripeReady =
    payoutMethod === "stripe" && stripeConnected === 1;

  const bankReady =
    payoutMethod === "bank" && bankStatus === "approved";

  const payoutReady = stripeReady || bankReady;

  const addressLocked = kycApproved && payoutReady;

  return {
    kycApproved,
    stripeReady,
    bankReady,
    payoutReady,
    addressLocked,
  };
};
